import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { fmtDateTime } from "../lib/format";

export default function AdminLogs() {
  const [logs, setLogs] = useState([]);
  const [stats, setStats] = useState(null);
  useEffect(() => {
    api.get("/admin/logs").then(r => setLogs(r.data));
    api.get("/admin/stats").then(r => setStats(r.data));
  }, []);
  return (
    <div className="space-y-6">
      <div>
        <div className="text-[11px] tracking-[0.2em] uppercase text-gold font-bold mb-2">Admin</div>
        <h1 className="font-display text-4xl font-bold tracking-tighter text-navy">System Logs</h1>
      </div>
      {stats && (
        <div className="grid grid-cols-2 md:grid-cols-6 gap-3">
          {Object.entries(stats).map(([k, v]) => (
            <div key={k} className="kpi-card">
              <div className="text-[10px] tracking-[0.2em] uppercase text-slate-500 font-bold">{k.replace(/_/g," ")}</div>
              <div className="font-display text-2xl font-bold text-navy">{typeof v === "number" && k.includes("revenue") ? `$${v}` : v}</div>
            </div>
          ))}
        </div>
      )}
      <div className="card-base overflow-x-auto">
        <table className="table-base">
          <thead><tr><th>Time</th><th>User</th><th>Action</th><th>Entity</th><th>Entity ID</th><th>Meta</th></tr></thead>
          <tbody>
            {logs.length === 0 && <tr><td colSpan={6} className="text-center py-10 text-slate-400">No logs.</td></tr>}
            {logs.map(l => (
              <tr key={l.log_id} data-testid={`log-${l.log_id}`}>
                <td className="text-xs text-slate-500 font-mono">{fmtDateTime(l.created_at)}</td>
                <td className="font-mono text-xs">{l.user_id || "—"}</td>
                <td><span className="badge accepted">{l.action}</span></td>
                <td className="capitalize">{l.entity}</td>
                <td className="font-mono text-xs">{l.entity_id}</td>
                <td className="text-xs text-slate-500 font-mono max-w-xs truncate">{JSON.stringify(l.meta)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
